module.exports = __webpack_public_path__ + "img/01_sp.d6762e1a.jpg";